import { defineStore } from "pinia";

import { fetchReservations } from "@/repositories/reservations.ts";
import type { Reservations } from "@/types/reservation";
import type { DateRange } from "@/types/date";

export const useReservations = defineStore("Reservations", {
  state: () => ({
    subjects: {} as Reservations,
    range: null as DateRange | null,
  }),

  getters: {
    incomeTax(state) {
      return state.subjects.income_tax ?? null;
    },
  },

  actions: {
    async load(range: DateRange) {
      this.range = range;
      this.subjects = await fetchReservations(range);
    },

    // Re-read after a transaction mutation so the reserve tracks the new history.
    async refresh() {
      if (this.range === null) {
        return;
      }

      this.subjects = await fetchReservations(this.range);
    },
  },
});
